import { render, staticRenderFns } from "./CompanyAddressEdit.vue?vue&type=template&id=3cdc44ee&"
import script from "./CompanyAddressEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports